<?xml version="1.0" encoding="UTF-8" standalone="no"?>
<!-- Created with Inkscape (http://www.inkscape.org/) -->

<svg
        xmlns:dc="http://purl.org/dc/elements/1.1/"
        xmlns:cc="http://creativecommons.org/ns#"
        xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
        xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        version="1.1"
        id="svg8"
        inkscape:version="0.92.3 (2405546, 2018-03-11)"
        sodipodi:docname="wishing-well-icon.svg">
  <defs
     id="defs2" />
  <sodipodi:namedview
     id="base"
     pagecolor="#ffffff"
     bordercolor="#666666"
     borderopacity="1.0"
     inkscape:pageopacity="0.0"
     inkscape:pageshadow="2"
     inkscape:zoom="22.627417"
     inkscape:cx="10.437363"
     inkscape:cy="11.03539"
     inkscape:document-units="px"
     inkscape:current-layer="svg8"
     showgrid="true"
     units="px"
     scale-x="1"
     inkscape:snap-bbox="true"
     inkscape:bbox-nodes="true"
     inkscape:window-width="1920"
     inkscape:window-height="1017"
     inkscape:window-x="0"
     inkscape:window-y="0"
     inkscape:window-maximized="1">
    <inkscape:grid
       type="xygrid"
       id="grid815" />
  </sodipodi:namedview>
  <metadata
     id="metadata5">
    <rdf:RDF>
      <cc:Work
         rdf:about="">
        <dc:format>image/svg+xml</dc:format>
        <dc:type
           rdf:resource="http://purl.org/dc/dcmitype/StillImage" />
        <dc:title></dc:title>
      </cc:Work>
    </rdf:RDF>
  </metadata>
  <g
     inkscape:label="Layer 1"
     inkscape:groupmode="layer"
     id="layer1" />
  <rect
     id="rect863"
     width="16"
     height="5"
     x="2"
     y="15" />
  <path
     d="M 4,0 0,4 H 20 L 16,0 Z m 1,1 h 5 V 2 H 4 Z"
     id="path865"
     inkscape:connector-curvature="0"
     sodipodi:nodetypes="cccccccccc" />
  <rect
     id="rect867"
     width="1"
     height="11"
     x="3"
     y="4" />
  <rect
     id="rect869"
     width="1"
     height="11"
     x="16"
     y="4" />
  <path
     d="m 4,7 v 1 h 4 v 2 H 6 l 1,3 h 3 l 1,-3 H 9 V 8 l 1,1 1,-1 1,1 1,-1 h 2 V 7 H 12 L 11,6 10,7 9,6 8,7 Z"
     id="rect871"
     inkscape:connector-curvature="0"
     sodipodi:nodetypes="cccccccccccccccccccccc" />
  <path
     d="m 15,7 h 4 v 2 h 1 v 1 H 18 V 8 h -3 z"
     id="path873"
     inkscape:connector-curvature="0"
     sodipodi:nodetypes="ccccccccc" />
</svg>
